import React from 'react';
import styled from 'styled-components';
import { Box } from '@material-ui/core';
import DeleteDark from 'src/assets/images/DeleteDark.svg';
import { makeStyles } from '@material-ui/core/styles';
import RowContainerMobile from './RowContainerMobile';
import NoItemTableData from 'src/pages/reportUsage/common/NoData';
import { isMobileDevice } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        // margin: 'auto',
        // maxWidth: 500,
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPadBottom: {
        paddingBottom: 5,
    },
}));

const DeleteAllDiv = styled.div`
    display: flex;
    font: var(--unnamed-font-style-normal) normal
        var(--unnamed-font-weight-normal) var(--unnamed-font-size-13) /
        var(--unnamed-line-spacing-22)
        var(--unnamed-font-family-avenir-next-world);
    letter-spacing: var(--unnamed-character-spacing-0);
    color: var(--unnamed-color-1010eb);
    text-align: left;
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: 0px;
    color: #1010eb;
    opacity: 1;
`;

const HeaderBox = styled(Box)`
    font-family: AvenirNextWorld Demi;
    font-size: 13px;
    letter-spacing: 0px;
    color: #3c3c3c;
    opacity: 1;
`;

const HeaderContainer = styled.div`
    margin-left: 1px;
    maring-right: 2px;
`;

const ItemsListContainerMobile = (props) => {
    const {
        toggleHidePricesBtn,
        filteredProduct,
        onAccountOwnedSeleted,
        deleteAll,
        deleteItem,
        editItem,
        addSerialNumber,
        editedItemList,
        lotSerialValueEntered,
        showBundlefromTableList,
        bundleExpandCollapseIconClickHandler,
        isFromReportScreen,
        vendorCaseErrorRedirection,
        onIsSerialUnknown,
    } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {filteredProduct && filteredProduct.length !== 0 ? (
                <HeaderContainer>
                    <HeaderBox
                        className={classes.paper}
                        my={1}
                        bgcolor={'#ffffff'}
                        boxShadow={2}
                        borderRadius={6}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div>{t('consignmentBilling.itemList.itemLotSerial')}</div>
                            <DeleteAllDiv
                                id={`delete-all-${filteredProduct.length}`}
                                onClick={deleteAll}
                            >
                                {t('consignmentBilling.itemList.deleteAll')}
                                <img
                                    src={DeleteDark}
                                    style={{
                                        width: 20,
                                        height: 20,
                                        marginLeft: '14.36px',
                                    }}
                                />
                            </DeleteAllDiv>
                        </div>
                    </HeaderBox>
                    {filteredProduct.map((item, index) => {
                        return (
                            <RowContainerMobile
                                key={`${item.cfn} ${index}`}
                                classes={classes}
                                item={item}
                                index={index}
                                editItem={editItem}
                                editedItemList={editedItemList}
                                addSerialNumber={addSerialNumber}
                                lotSerialValueEntered={lotSerialValueEntered}
                                onAccountOwnedSeleted={onAccountOwnedSeleted}
                                deleteItem={deleteItem}
                                displayPrice={toggleHidePricesBtn === 'hideBtn'}
                                showBundlefromTableList={
                                    showBundlefromTableList
                                }
                                bundleExpandCollapseIconClickHandler={
                                    bundleExpandCollapseIconClickHandler
                                }
                                isFromReportScreen={isFromReportScreen}
                                vendorCaseErrorRedirection={
                                    vendorCaseErrorRedirection
                                }
                                onIsSerialUnknown={onIsSerialUnknown}
                            />
                        );
                    })}
                </HeaderContainer>
            ) : (
                <NoItemTableData
                    padding={isMobileDevice() ? '8px 14px' : '8px 0px'}
                    marginTop={'6px'}
                    content={t('reportUsage.noUsageItemsMsg')}
                />
            )}
        </React.Fragment>
    );
};

export default ItemsListContainerMobile;
